import {
    CatalogContainerFragment,
    CategoryFragment,
    ProductItemFragment,
    SelectedCategoryFragment,
} from '@/features/graphql/generated/graphql'
import { Category } from '@/features/pos/components/ProductCatalog/parts/CategoryBar/types'
import {
    ItemType,
    containersCategoryId,
} from '@/features/pos/components/ProductCatalog/parts/ProductList/constants'
import {
    Container,
    Product,
    SectionHeader,
} from '@/features/pos/components/ProductCatalog/parts/ProductList/types'
import { formatPrice } from '@/utils/priceHelper'

export const transformCategory = (
    category: CategoryFragment & { subcategories?: CategoryFragment[] | null }
): Category => ({
    id: category.uuid,
    name: category.name,
    subcategories: category.subcategories?.map(transformCategory),
})

export const appendContainersCategory = (
    categories: Category[],
    name: string,
    hasContainers: boolean
): Category[] => (hasContainers ? [...categories, { id: containersCategoryId, name }] : categories)

export const transformSubcategoryToSectionHeader = (
    subcategory: SelectedCategoryFragment
): SectionHeader => ({
    type: ItemType.Header,
    id: subcategory.uuid,
    name: subcategory.name,
})

export const transformProduct = (product: ProductItemFragment, index: number): Product => ({
    type: ItemType.Product,
    id: product.uuid,
    name: product.name,
    price: formatPrice(product.priceInfo.price.amount, product.priceInfo.price.currency),
    soldOut: product.soldOut,
    variantQuantity: product.productVariants.length,
    ...(product.label && {
        label: { name: product.label.name, color: product.label.color ?? undefined },
    }),
    index,
})

export const transformContainer = (
    container: CatalogContainerFragment,
    index: number
): Container => ({
    type: ItemType.Container,
    id: container.uuid,
    name: container.internalName,
    price: formatPrice(container.price.amount, container.price.currency),
    index,
})
